export default __webpack_public_path__ + "static/media/18.551094d9.jpg";